export function createFlow() {
  const flow = [];
  const builder = {
    step(id, component, params, shouldSkip) {
      flow.push({
        type: 'step',
        id,
        component,
        params,
        shouldSkip
      });
      return builder;
    },
    action(id, handler) {
      flow.push({
        type: 'action',
        id,
        handler: handler
      });
      return builder;
    },
    task(id, handler) {
      flow.push({
        type: 'task',
        id,
        handler
      });
      return builder;
    },
    build() {
      return [...flow];
    }
  };
  return builder;
}
//# sourceMappingURL=createFlow.js.map